export const BOARD_ROUTE_IDS = [
  'dashboard',
  'media',
  'mediaList',
  'mediaListDetail',
  'reports',
  'reportsHour',
  'reportsMedia',
  'reportsInventory',
  'reportsAdExchange',
  'account',
  'accountHistory',
  'accountProfile',
  'accountConfirm',
  'accountData',
  'platform',
  'platformUserDetail',
  'platformAdmin',
  'platformTerm',
  'platformTermDetail',
  'platformHistory',
  'platformAdExchange',
  'platformHistoryDetail',
  'platformAdExchangeDetail',
  'myPageUser',
  'myPageAdmin',
  'notice',
  'noticeDetail',
  'inquiry',
  'inquiryDetail',
  'apiGuide',
  'apiTest',
]

const NORMAL_ROUTE_IDS = new Set([
  'dashboard',
  'reports',
  'reportsHour',
  'reportsInventory',
  'reportsAdExchange',
  'account',
  'accountHistory',
  'myPageUser',
  'notice',
  'noticeDetail',
  'apiGuide',
  'apiTest',
])

const SUPER_ADMIN_ROUTE_IDS = new Set([
  'platformHistory',
  'platformHistoryDetail',
])

export const canAccessBoardRoute = (role, routeId) => {
  if (!BOARD_ROUTE_IDS.includes(routeId)) {
    return false
  }

  if (role === 'NORMAL') {
    return NORMAL_ROUTE_IDS.has(routeId)
  }

  if (SUPER_ADMIN_ROUTE_IDS.has(routeId)) {
    return role === 'SUPER_ADMIN'
  }

  return ['ADMIN', 'SUPER_ADMIN'].includes(role)
}
